export default __webpack_public_path__ + "static/media/ishopify-sidebar-layers-large.d2cf867c.png";